import { LocalStoreService } from './local-store.service';
import { DotSettings } from './settings.model';
import { AppConfig } from './app.config';
import { Inject, Injectable, NgModule } from '@angular/core';
import { SiteBrowserState } from './site-browser.state';

/**
 * Stores and returns the DotSettings class
 */




export class SettingsStorageService {
    configKey: string;

    constructor(
        private config: AppConfig,
        private localStoreService: LocalStoreService,
        private siteBrowserState: SiteBrowserState
    ) {
        this.configKey = config.dotCMSURLKey;
    }

    getSettings(): DotSettings {
        let dSettings: DotSettings = JSON.parse(this.localStoreService.getValue(this.configKey));
        if (dSettings == null) {
            dSettings = new DotSettings();
        }
        return dSettings;
    }

    /**
     * Stores the DotSettings object
     * @param siteURL
     * @param JWT
     */
    storeSettings(siteURL: string, JWT: string): void {
        const dSettings: DotSettings = new DotSettings();
        dSettings.site = siteURL;
        dSettings.jwt = JWT;
        this.localStoreService.storeValue(this.configKey, JSON.stringify(dSettings));
    }

    /**
     * removes stored settings
     */
    clearSettings(): void {
        this.localStoreService.clearValue(this.configKey);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
{ type: Inject, args: ['config', ] },
{ type: Inject, args: ['localStoreService', ] },
{ type: Inject, args: ['siteBrowserState', ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AppConfig, },
{type: LocalStoreService, },
{type: SiteBrowserState, },
];
}


export class DotSettingsStorageModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    providers: [SiteBrowserState, AppConfig, LocalStoreService, SettingsStorageService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
